import { useEasyProvider } from '@shared/components/EasyProvider'
import { useInfiniteList } from '@shared/components/InfiniteList'
import { useEffect } from 'react'

export const useEstimationsDialog = () => {
    const {
        instance,
        setEstimationsVisibility
    } = useEasyProvider()
    const manager = useInfiniteList({
        key: ['estimations', instance?.id],
        endpoint: 'estimations/',
        params: { office: instance?.id },
    })

    const handleClose = () => setEstimationsVisibility(false)

    useEffect(() => {
        manager.virtualizer.measure()
    }, [])

    return {
        manager,
        handleClose
    }
}